module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-0-50.2f380295.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-0-50.png
// module id = 2548
// module chunks = 11